module.exports = __webpack_public_path__ + "img/7_94.fe794ecf.png";